import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useEffect, useRef } from "react";
var NavigationContent = function NavigationContent2(param) {
  var { render, children } = param;
  return render(children);
};
function useComponent(render) {
  var renderRef = useRef(render);
  renderRef.current = render;
  useEffect(function() {
    renderRef.current = null;
  });
  return useRef(/* @__PURE__ */ forwardRef(function(param, _ref) {
    var { children } = param;
    var _$render = renderRef.current;
    if (_$render === null) {
      throw new Error("The returned component must be rendered in the same render phase as the hook.");
    }
    return /* @__PURE__ */ _jsx(NavigationContent, {
      render: _$render,
      children
    });
  })).current;
}
export {
  useComponent
};
//# sourceMappingURL=useComponent.js.map
